import { Card } from 'antd';
import React from 'react';
import styled from 'styled-components';

import Secondary from '../../../../shared/ui/SecondaryText';

type Props = {
    readonly title: string;
    readonly value: number | string;
    readonly difference?: number;
    readonly highlight?: boolean;
    readonly loading?: boolean;
    readonly width?: string;
};

export const StatsWidget = ({
    width,
    loading,
    title,
    highlight,
    difference,
    value,
}: Props) => {
    return (
        <StyledCard width={width} loading={loading} type='inner'>
            <Secondary>{title}</Secondary>
            <StyledValue>
                <ValueText>{value.toLocaleString('ru-RU')}</ValueText>
                {difference !== undefined && (
                    <DifferenceText
                        $difference={difference}
                        $highlight={highlight}
                    >
                        {difference}
                    </DifferenceText>
                )}
            </StyledValue>
        </StyledCard>
    );
};

const StyledCard = styled(Card)<{ width?: string }>`
    min-width: ${props => props.width || '270px'};
    flex: 1 0 24%;
`;
const StyledValue = styled.div<{ $difference?: number; $highlight?: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: end;
`;

const ValueText = styled.div`
    font-size: 2em;
    color: #2f54eb;
    font-weight: 300;
`;

const DifferenceText = styled.div<{
    $difference: number;
    $highlight?: boolean;
}>`
    ::after {
        content: '%';
    }
    color: ${props =>
        props.$highlight
            ? props.$difference < 0
                ? '#BD2B30'
                : '#139C55'
            : 'rgba(37, 33, 41, 0.45)'};
`;
